import { ArrowUpRight, MessageCircleMore } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../primitives/tooltip';

interface SidebarHelpProps {
  title: string;
  text: string;
  actionLabel: string;
  /** Where the button goes, e.g. a mailto: link */
  href: string;
  /** Collapsed sidebar: only an icon button with the action in a tooltip */
  iconsOnly?: boolean;
}

/** "Need a little help?" card at the bottom of the AppLayout sidebar */
export function SidebarHelp({ title, text, actionLabel, href, iconsOnly }: SidebarHelpProps): ReactNode {
  if (iconsOnly) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button asChild variant="ghost" size="icon" className="self-center text-muted-foreground">
            <a href={href} aria-label={actionLabel}>
              <MessageCircleMore />
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">{actionLabel}</TooltipContent>
      </Tooltip>
    );
  }
  return (
    <div className="mx-1 grid justify-items-center gap-1.5 rounded-2xl bg-muted px-4 py-3 text-center tall:gap-2 tall:py-5">
      <MessageCircleMore
        className="size-7 text-secondary short:hidden tall:size-9"
        strokeWidth={1.5}
        aria-hidden
      />
      <p className="text-sm font-semibold text-secondary">{title}</p>
      <p className="text-xs leading-relaxed text-muted-foreground short:hidden">{text}</p>
      <Button asChild className="mt-1 w-full tall:mt-2">
        <a href={href}>
          {actionLabel} <ArrowUpRight />
        </a>
      </Button>
    </div>
  );
}
